<template>
  <div class="wrap page1 f1 fdc">
    <div class="wrap2">
      <div class="preset-templates df fdc aic jcsb">
        <h3 class="nexa-font-bold mb_1a">
          Let's quick-start with a new pricing project
        </h3>
        <div class="preset-templates-list df jcsb">
          <span v-on:click="createNewEmptyProject()" class="preset-template df fdc jcsb aic">
            <p class="nexa-font-bold f1">Blank Custom Project</p>
            <img src="/images/preset-5-spreadhseet.svg" class="icon-with-rollover" alt="">
            <img src="/images/preset-5-spreadsheet-2.png" alt="">
            <span class="subheading">Empty Sheet</span>
          </span>
          <span v-on:click="createNewProject('basic-website')" class="preset-template df fdc jcsb aic">
            <p class="nexa-font-bold f1">Small Level Custom Website</p>
            <img src="/images/Icon-SmallWebsite.svg" class="icon-with-rollover" alt="">
            <img src="/images/Icon-SmallWebsite-active.svg" class="purp" alt="">
            <span class="subheading">Product Portfolio Site
            </span>
          </span>
          <!-- <span v-on:click="createNewProject('small-website')" class="preset-template df fdc aic">
            <p class="nexa-font-bold">Small Website</p>
            <img src="/images/preset-4-website.svg" class="icon-with-rollover" alt="">
            <img src="/images/preset-4-website-2.png" alt="">
          </span> -->
          <span v-on:click="createNewProject('small-website-wordpress')" class="preset-template df fdc jcsb aic">
            <p class="nexa-font-bold f1">Small Level Website Wordpress</p>
            <img src="/images/Icon-SmallWordpress.svg" class="icon-with-rollover" alt="">
            <img src="/images/Icon-SmallWordpress-active.svg" alt="">
            <span class="subheading">Corporate Portfolio Site</span>
          </span>
          <span v-on:click="createNewProject('medium-webapp')" class="preset-template df fdc jcsb aic">
            <p class="nexa-font-bold">Medium Level Web App</p>
            <img src="/images/Icon-WebApp-1.svg" class="icon-with-rollover" alt="">
            <img src="/images/Icon-WebApp-active-1.svg" alt="">
            <span class="subheading">Job Portal App</span>
          </span>
          <span v-on:click="createNewProject('large-webapp')" class="preset-template df fdc jcsb aic">
            <p class="nexa-font-bold">Large Level Web App</p>
            <img src="/images/Icon-WebApp-1.svg" class="icon-with-rollover" alt="">
            <img src="/images/Icon-WebApp-active-1.svg" alt="">
            <span class="subheading">Learning Management App</span>
          </span>
          <span v-on:click="createNewProject('medium-desktop-app')" class="preset-template df fdc jcsb aic">
            <p class="nexa-font-bold">Medium Level Desktop App</p>
            <img src="/images/Icon-DesktopApp.svg" class="icon-with-rollover" alt="">
            <img src="/images/Icon-DesktopApp-active.svg" alt="">
            <span class="subheading">Inventory Management App</span>
          </span>
          <span v-on:click="createNewProject('small-mobile-app')" class="preset-template df fdc jcsb aic">
            <p class="nexa-font-bold">Small Mobile App</p>
            <img src="/images/Icon-MobileApp.svg" class="icon-with-rollover" alt="">
            <img src="/images/Icon-MobileApp-active.svg" alt="">
            <span class="subheading">iOS / Android App</span>
          </span>
          <span v-on:click="createNewProject('software-assurance')" class="preset-template df fdc jcsb aic">
            <p class="nexa-font-bold">Software<br/>Q/A</p>
            <img src="/images/Icon-QA.svg" class="icon-with-rollover" alt="">
            <img src="/images/Icon-QA.svg" alt="">
            <span class="subheading">Assurance Plan</span>
          </span>
          <span v-on:click="createNewProject('online-conference')" class="preset-template df fdc jcsb aic">
            <p class="nexa-font-bold">Live Online Event</p>
            <img src="/images/Icon-ConferenceEvent.svg" class="icon-with-rollover" alt="">
            <img src="/images/Icon-ConferenceEvent-active.svg" alt="">
            <span class="subheading">Corporate Convention </span>
          </span>
          <!-- <span v-on:click="createNewProject('responsive-website')" class="preset-template df fdc aic">
            <p class="nexa-font-bold">Responsive Website</p>
            <img src="/images/preset-3-responsive.svg" class="icon-with-rollover" alt="">
            <img src="/images/preset-3-responsive-2.png" alt="">
          </span>
          <span v-on:click="createNewProject('ios-android-app')" class="preset-template df fdc aic">
            <p class="nexa-font-bold">iOS / Android App</p>
            <img src="/images/preset-2-smartphone.svg" class="icon-with-rollover" alt="">
            <img src="/images/preset-2-smartphone-2.png" alt="">
          </span>
          <span v-on:click="createNewProject('enterprise-mvp')" class="preset-template df fdc aic">
            <p class="nexa-font-bold">Enterprise MVP</p>
            <img src="/images/preset-1-startup.svg" class="icon-with-rollover" alt="">
            <img src="/images/preset-1-startup-2.png" alt="">
          </span> -->
        </div>
      </div>
      <div class="existing-projects-heading df jcsb">
      </div>
      <!-- <button v-on:click="test()" class="test">test</button> -->
      <ProjectCard
        v-for="(item, key) in this.projects"
        v-bind:key="key"
        v-bind:id="key"
        v-bind:cardIndex="Object.keys(myProjectListWithDetails).indexOf(key)"
        v-bind:name="item.name"
        v-bind:type="item.type"
        v-bind:image="item.image"
        v-bind:created="item.created"
        v-bind:status="item.status"
        v-bind:totalPrice="totalPriceSum(key)"
        v-bind:totalHours="totalHoursSum(key)"
      />
      <span v-bind:class="{'shift-up-30': !emailVerified,
                            'add-blocked': addBlocked()
                          }" v-on:click="addNewProject()" class="add">
        <span v-bind:class="{'add-blocked': addBlocked()}" class="box hover-box posabs maximum-plan-box">
          <span class="hover-box-top df">
            <img src="/images/Warning-Icon-Small.png" alt="">
            <h3 class="nexa-font-bold">Maximum Plan Reached</h3>
          </span>
          <span class="hover-box-bottom df fdc">
            <p class="gg-font box-message">You’ve hit the maximum number of projects for your current plan</p>
            <button class="button-x" v-on:click="goTo($event, '/pricing')">Upgrade Your Plan</button>
          </span>
        </span>
      </span>

    </div>
    <div  class="no-projects mb0"
          v-if="loading">
      <p class="loading-projects-text" v-on:click="test()">Loading projects</p>
    </div>
    <div  v-else-if="(Object.keys(myProjectList).length == 0 && Object.keys(myProjectListWithDetails).length == 0)"
          class="no-projects"
          v-on:click="test()">
      <p class="you-have-no-projects gg-font">You have 0 projects</p>
      <button class="button-form button-form-active" v-on:click="addNewProject()">Create One Now</button>
    </div>
    <span class="f1"></span>
    <CreateNewProject v-on:closeNewProject="closeNewProject" v-if="creatingNewProject"/>
  </div>
</template>

<script>
import CreateNewProject from '../project/CreateNewProject'
import ProjectCard from '../project/ProjectCard'
import router from '../../router'
import ProjectUtil from '../../util/project';
import { mapGetters } from 'vuex';

export default {
  name: 'DashboardProjects',
  data () {
    return {
      projectName: 'New Project',
      selectedPriceRange: 'mid',
      creatingNewProject: false
    }
  },
  props: [],
  components: {
    CreateNewProject,
    ProjectCard
  },
  methods: {
    goTo (e, path) {
      e.stopPropagation()
      router.push(path)
    },
    addBlocked () {
      return false
    },
    createNewProject (preset) {
      // console.log('createNewProjectFromPreset', this.$store.getters.companyCost)
      this.$store.dispatch('createNewProjectFromPreset', {
        companyPlan: this.$store.getters.companyPlan,
        numberOfProjects: Object.keys(this.myProjectListWithDetails).length,
        name: this.projectName,
        myID: this.$store.getters.uid,
        rate: this.$store.getters.companyRate,
        cost: this.$store.getters.userData.companyCost,
        contingency: this.$store.getters.companyContingency,
        companyTasks: this.$store.getters.companyTasks,
        type: 'website',
        preset: preset
      }).then(() => {
        this.$emit('closeNewProject')
      })
    },
    createNewEmptyProject () {
      console.log('createNewProject', this.$store.getters.companyCost)
      this.$store.dispatch('createNewProject', {
        companyPlan: this.$store.getters.companyPlan,
        numberOfProjects: Object.keys(this.myProjectListWithDetails).length,
        name: 'New Custom Project',
        myID: this.$store.getters.uid,
        rate: this.$store.getters.companyRate,
        cost: this.$store.getters.userData.companyCost,
        contingency: this.$store.getters.companyContingency,
        companyTasks: this.$store.getters.companyTasks
      }).then(() => {
        console.log('after createNewProject')
        // close new project window
        this.$emit('closeNewProject')
      })
    },
    totalPriceSum (projectKey) {
      var rate = this.myProjectListWithDetailsFull[projectKey].blendedRate
      var modules = this.myProjectListWithDetailsFull[projectKey]['modules']
      var columns = this.myProjectListWithDetailsFull[projectKey].moduleColumns
      var overrides = this.myProjectListWithDetailsFull[projectKey].overrides
      const total = ProjectUtil.totalPriceWithOverrides(modules, columns, rate, overrides)
      return ProjectUtil.priceFormatterValue(total)
    },
    totalHoursSum(projectKey) {
      var modules = this.myProjectListWithDetailsFull[projectKey] ? this.myProjectListWithDetailsFull[projectKey].modules : []
      var columns = this.myProjectListWithDetailsFull[projectKey] ? this.myProjectListWithDetailsFull[projectKey].moduleColumns : []
      return ProjectUtil.totalHours(modules, columns)
    },
    addNewProject () {
       this.creatingNewProject = true
    },
    closeNewProject () {
      this.creatingNewProject = false
    }
  },
  computed: {
    ...mapGetters(['myProjectListWithDetails', 'myProjectListWithDetailsFull', 'myProjectList', 'emailVerified', 'loading']),
    projects () {
      const sorted = Object.keys(this.myProjectListWithDetails).map(k => {
        if (!this.myProjectListWithDetails[k].edited) {
          this.myProjectListWithDetails[k].edited = this.myProjectListWithDetails[k].created
        }
        return {key: k, value: this.myProjectListWithDetails[k]}
      }).sort((a, b) => {
        return new Date(b.value.edited) - new Date(a.value.edited)
      });
      return sorted.reduce((acc, x) => {
        acc[x.key] = x.value
        return acc;
      }, {})
    }
  },
  watch: {
    myProjectListWithDetails() {}
  },
  created () {
    this.$store.subscribe((mutation, state) => {
      if (['REMOVE_PROJECT', 'ADD_PROJECT', 'SAVE_USER_DATA', 'ADD_PROJECT_FULL'].includes(mutation.type)) {
        this.$forceUpdate()
      }
    })
  }
}
</script>

<style lang="scss">
  //
  // Wrapper
  //
  main > .wrapper {
    align-items: unset;
  }
</style>

<style scoped lang="scss">
@import "../../styles/settings.scss";



.test {
  width: 100%;
}
.wrap {
  width: 100%;
  padding: 0;
  display: -webkit-flex;
  display: -moz-flex;
  display: -ms-flex;
  display: -o-flex;
  display: flex;
  /*position: relative;*/
}
.wrap2 {
  justify-content: center;
  position: relative;
  padding-top: 40px;
  padding-bottom: 40px;
  padding-top: 0;
  display: -webkit-flex;
  display: -moz-flex;
  display: -ms-flex;
  display: -o-flex;
  display: flex;
  -webkit-flex-direction: row;
  -moz-flex-direction: row;
  -ms-flex-direction: row;
  -o-flex-direction: row;
  flex-direction: row;
  -webkit-flex-wrap: wrap;
  -moz-flex-wrap: wrap;
  -ms-flex-wrap: wrap;
  -o-flex-wrap: wrap;
  flex-wrap: wrap;
  /*flex: 1;*/
  height: 100%;
  -ms-align-items: center;
  align-items: center;

  // Responsive Style
  // @media max-width: 768px
  @media(max-width: 768px) {
    padding-bottom: 0;
  }
}
.add {
  /*cursor: pointer;*/
  z-index: 6;
  height: 60px;
  width: 60px;
  overflow: visible;
  border-radius: 50%;
  position: absolute;
  top: 0;
  right: 40px;
  transform: translateY(-50%);
  display: -webkit-flex;
  display: -moz-flex;
  display: -ms-flex;
  display: -o-flex;
  display: flex;
  justify-content: center;
  -ms-align-items: center;
  align-items: center;
  background-position: center;

  // Responsive Style
  // @media max-width: 768px
  @media(max-width: 768px) {
    width: 48px;
    height: 48px;
    right: 20px;
  }
}
.add-button {
  cursor: pointer;
  z-index: 6;
  height: 60px;
  width: 60px;
  box-shadow: 0 1px 3px 0 rgba(0,0,0,0.26);
  border-radius: 50%;
  display: -webkit-flex;
  display: -moz-flex;
  display: -ms-flex;
  display: -o-flex;
  display: flex;
  justify-content: center;
  -ms-align-items: center;
  align-items: center;
  color: white;
  font-size: 28px;
  font-weight: 500;
  background-image: url(/images/plus-full.png);
  background-position: center;

  // Responsive Style
  // @media max-width: 768px
  @media(max-width: 768px) {
    width: 48px;
    height: 48px;
  }
}
.add.add-blocked {
  .add-button {
    opacity: 0.6;
  }

  &:hover {
    .hover-box {
      display: block;
    }
  }
}
.add-button-lock {
  left: 0;
  top: 0;
  display: none;
}
.add-button-lock.add-blocked {
  display: block;
}
.no-projects {
  /*padding: 100px 120px;*/
  max-height: 300px;
  width: 400px;
  -ms-align-self: center;
  align-self: center;
  /*position: absolute;*/
  /*left: 50%;*/
  /*top: 50%;*/
  /*transform: translate(-50%, -50%);*/

  & > p {
    font-size: 32px;
    color: $grey3;
    line-height: 43px;
    margin-bottom: 40px;
    text-align: center;
  }


  // Responsive Style
  // @media max-width: 768px
  @media(max-width: 768px) {
    width: auto;

    // p
    & > p {
      font-size: 18px;
      margin-bottom: 10px;
    }

    // button
    button {
      padding-top: 16px;
      padding-bottom: 16px;
      min-width: 240px;
    }
  }
}

.mb0 {
  & > p {
    margin-bottom: 0;
  }
}
.shift-up-30 {
  top: -30px;
}
h3 {
  font-size: 18px;
  color: $grey2;
  font-weight: 400;
  margin-bottom: 0px;
}
.preset-templates {
  width: 100%;
  min-width: 100vw;
  background-color: #eee;
  min-height: 212px;
  padding: 20px;
  padding-top: 32px;
  padding-bottom: 0;

  // Responsive Style
  // @media max-width: 1280px
  @media(max-width: 1280px) {
    .preset-templates-list {
      width: 100%;
      display: flex;
      flex-wrap: nowrap;
      overflow-x: auto;
      -webkit-overflow-scrolling: touch;

      // span
      > span {
        flex: 0 0 auto;
      }
    }
  }

  // Responsive Style
  // @media max-width: 768px
  @media(max-width: 768px) {
    padding-top: 25px;

    // h3
    > h3 {font-size: 16px;}
  }
}


//
// Preset Template
//
.preset-template {
  cursor: pointer;
  padding: 15px;
  margin-right: 6px;
  margin-left: 6px;
  min-height: 140px;
  min-width: 118px;
  width: 118px;

  // p
  p {
    font-weight: 400;
    color: #5c6975;
    padding-bottom: 15px;
    cursor: pointer;
    font-family: 'GG';
    font-size: 12px;
    letter-spacing: 0;
    line-height: 13px;
    text-align: center;
    display: flex;
    align-items: center;
    min-height: 60px;
  }

  // img
  img {
    cursor: pointer;
    height: 57px;
    path {
      fill: red;
    }
  }

  // hover
  &:hover {
    background-color: #9999990f;
    border-radius: 10px 10px 0 0;
    p {
      color: $primaryColor;
    }
    .icon-with-rollover {
      display: none;
      & + img {
        display: block;
      }
    }
  }

  // Responsive Style
  // @media max-width: 768px
  @media(max-width: 768px) {
    // p
    p {
      font-size: 10px;
    }
  }
}

.existing-projects-heading {
  width: 100%;
  min-width: 100%;
  padding: 20px;
  padding-top: 40px;
  padding-bottom: 20px;
  position: relative;
}

.sort-by {
  position: absolute;
  left: 0;
  top: 50%;
  transform: translateY(-50%);
}

.icon-with-rollover {
  & + img {
    display: none;
  }
}

.loading-projects-text {
  text-align: center;
}

.recent-pricing-projects-title {
  font-size: 24px;
  color: $grey2;

  // Responsive Style
  // @media max-width: 768px
  @media(max-width: 768px) {
    font-size: 18px;
  }
}

.maximum-plan-box {
  width: 300px;
  top: 40%;
  right: 50%;
  display: none;

  img {
    object-fit: contain;
  }

  h3 {
    font-size: 16px;
    margin-left: 10px;
  }

  .box-message {
    font-size: 12px;
    line-height: 1.3em;
    text-align: center;
    margin-bottom: $boxPaddingVertical;
  }
  .button-form-active {
    width: unset;
  }
}
.maximum-plan-box.add-blocked {
  /*display: block;*/
}
.purp {
  color: #5558FF;
}


//
// Subheading
//
.subheading {
  flex: 1;
  margin-top: 10px;
  margin-bottom: 12px;
  color: #5C6975;
  font-family: 'GG';
  font-weight: 400;
  font-size: 10px;
  letter-spacing: 0;
  line-height: 12px;
  text-align: center;
}


.mb_1a {
  margin-bottom: 10px;
}
</style>
